import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export const StyledCard = styled.div`
  box-shadow: 0 0 1px 0 #a8b9d5, 0 12px 24px -6px #ebf2ff;
  background: ${themeGet('color.colorWhite')};
  border-radius: 3px;
  padding: ${themeGet('scale.scaleUp05')};

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    padding: ${themeGet('scale.scaleUp07')} ${themeGet('scale.scaleUp05')};
  }
`;

export default StyledCard;
